import { DiscoverBreadcrumbs } from 'shared/models';
import { atom } from 'jotai';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

type DiscoverBreadCrumbsStore = { [key: string]: DiscoverBreadcrumbs | undefined };

export const $DiscoverBreadCrumbsStore = atom<DiscoverBreadCrumbsStore>({});

export const $DiscoverBreadcrumbs = safeAtomFamily((keyword: string) => {
  const a = atom(
    (get) => {
      const data = get($DiscoverBreadCrumbsStore)[keyword];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, input: DiscoverBreadcrumbs) => {
      const old = get($DiscoverBreadCrumbsStore);
      set($DiscoverBreadCrumbsStore, { ...old, [keyword]: input });
    },
  );

  a.debugLabel = `$DiscoverBreadcrumbs+${encodeURIComponent(keyword)}`;

  return a;
});
